'use strict';

Odigeo.defineWidget('post_booking_accommodation', Odigeo.Widget.extend({
    viewClass: require('../modules/views/post_booking_accommodation'),
    modelClass: require('../modules/models/post_booking_accommodation'),

    load: function(booking) {
        this.model.loadPostBookingAccommodation(booking);
    },

    error: function(typeError) {
        this.model.loadPostBookingAccommodation(Odigeo._.zipObject([typeError], [true]));
    },
}));
